import React from "react";
import Hero from "./Hero";
import Services from "./Service"; 
const Home = () => {
  return (
    <div>
      <Hero />
      <Services />
    </div>
  );
};

export default Home;
